module.exports = __webpack_public_path__ + "static/fonts/Fact-ThinItalic.5d8c26d.woff";